module.exports = __webpack_public_path__ + "img/check-active-green.cdd0ea6b.svg";